export default __webpack_public_path__ + "static/media/Heebo-Medium.d0da85fd.ttf";